import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import ImpactStats from "./components/ImpactStats";
import About from "./components/About";
import Programs from "./components/Programs";
import Donate from "./components/Donate";
import Volunteer from "./components/Volunteer";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <ImpactStats />
        <About />
        <Programs />
        <Donate />
        <Volunteer />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}